import React, { PureComponent } from 'react'
import moment from 'moment'
import { get, post, put, logout } from './util'
import Modal from './components/Modal'
import Button from './components/Button'

const EMPTY_TOKEN = '$EMPTY_$TOKEN'

class Profile extends PureComponent {
  state = {
    tab: 'details',
    currentAdminPassword: '',
    adminPassword: '',
    passwordAgain: '',
    confirmReset: false,
    loading: false,
    token: null,
    defaultQuota: ''
  }

  componentDidUpdate (prevProps) {
    if (!prevProps.show && this.props.show) {
      this.setState({ loading: true })
      get('admin/info')
        .then(company => {
          this.setState({
            company,
            loading: false,
            defaultQuota: company.defaultQuotaPerUser
          })
        })
        .catch(e => console.error(e))

      get('admin/api-token').then(({ apiToken }) =>
        this.setState({ token: apiToken || EMPTY_TOKEN })
      )
    }
  }

  handleUpdate = () => {
    if (!this.state.currentAdminPassword || !this.state.adminPassword) {
      alert('Please enter the current and new password')
      return
    }
    if (this.state.passwordAgain !== this.state.adminPassword) {
      alert('The two passwords do not match')
      return
    }
    put('admin/info', {
      adminPassword: this.state.adminPassword,
      currentAdminPassword: this.state.currentAdminPassword
    })
      .then(() => {
        alert('Updated successfully. Please sign in again.')
        logout()
        this.props.history.push('/login')
      })
      .catch(e => {
        alert('Failed to update: ' + e.message)
      })
  }

  saveQuota = () => {
    put('admin/info', {
      defaultQuotaPerUser: this.state.defaultQuota
    })
      .then(() => {
        alert('Saved successfully')
        this.props.onChangeDefaultQuota(this.state.defaultQuota)
      })
      .catch(e => {
        alert('Failed to Save: ' + e.message)
      })
  }

  resetToken = () => {
    const loadingToken = '........-....-....-....-............'
    this.setState({ confirmReset: false, token: loadingToken })
    post('admin/api-token', {}).then(({ apiToken }) => {
      this.setState({ token: loadingToken })
      setTimeout(() => {
        this.setState({ token: apiToken })
      }, 1000)
    }).catch(e => {
      alert('Failed to reset: ' + e.message)
    })
  }

  renderDetails () {
    if (!this.state.company) {
      return null
    }
    const lines = [
      ['Company ID', this.state.company.companyID],
      ['Company Name', this.state.company.companyName],
      ['Admin Email', this.state.company.adminEmail],
      ['Device Quota', this.state.company.quota],
      ['Used Quota', `${this.state.company.usedQuota}`],
      ['Expired Date', moment(this.state.company.expiredDate).format('MMM D, YYYY')]
    ]
    const usage =
      this.state.company.quota > 0
        ? (this.state.company.usedQuota / this.state.company.quota) * 100
        : 0
    return (
      <div className='space-y-4'>
        <div className='space-y-3 text-sm text-slate-600'>
          {lines.map(([label, value]) => (
            <div key={label} className='flex items-center justify-between'>
              <span>{label}</span>
              <span className='font-semibold text-ink'>{value}</span>
            </div>
          ))}
        </div>
        <div>
          <p className='text-sm text-slate-500'>Quota Usage</p>
          <p className='text-lg font-semibold text-ink'>
            {this.state.company.usedQuota} / {this.state.company.quota}
          </p>
          <div className='mt-2 h-2 rounded-full bg-slate-100'>
            <div className='h-full rounded-full bg-blue-500' style={{ width: `${Math.min(100, usage)}%` }} />
          </div>
        </div>
      </div>
    )
  }

  renderPassword () {
    return (
      <div className='space-y-4'>
        <label className='text-sm font-medium text-slate-600'>
          Current Password
          <input
            type='password'
            className='mt-1 w-full rounded-2xl border border-slate-200 px-4 py-2.5 focus:border-ink focus:ring-1 focus:ring-ink'
            value={this.state.currentAdminPassword}
            onChange={e => this.setState({ currentAdminPassword: e.target.value })}
          />
        </label>
        <label className='text-sm font-medium text-slate-600'>
          New Password
          <input
            type='password'
            className='mt-1 w-full rounded-2xl border border-slate-200 px-4 py-2.5 focus:border-ink focus:ring-1 focus:ring-ink'
            value={this.state.adminPassword}
            onChange={e => this.setState({ adminPassword: e.target.value })}
          />
        </label>
        <label className='text-sm font-medium text-slate-600'>
          Confirm Password
          <input
            type='password'
            className='mt-1 w-full rounded-2xl border border-slate-200 px-4 py-2.5 focus:border-ink focus:ring-1 focus:ring-ink'
            value={this.state.passwordAgain}
            onChange={e => this.setState({ passwordAgain: e.target.value })}
          />
        </label>
        <Button className='mt-2' onClick={this.handleUpdate}>Update Password</Button>
      </div>
    )
  }

  renderQuota () {
    if (!this.state.company) return null
    return (
      <div className='space-y-3'>
        <label className='text-sm font-medium text-slate-600'>
          Default Quota per User
          <input
            type='number'
            className='mt-1 w-40 rounded-2xl border border-slate-200 px-4 py-2.5 focus:border-ink focus:ring-1 focus:ring-ink'
            value={this.state.defaultQuota}
            onChange={e => this.setState({ defaultQuota: Number(e.target.value) || 0 })}
          />
        </label>
        <Button onClick={this.saveQuota}>Save</Button>
      </div>
    )
  }

  renderToken () {
    if (!this.state.token) return null
    return (
      <div className='space-y-4'>
        {this.state.token === EMPTY_TOKEN ? (
          <p className='text-sm text-slate-500'>No token</p>
        ) : (
          <div className='flex items-center gap-2'>
            <span>Current Token:</span>
            <span className='px-3 py-1 rounded-full bg-slate-100 text-sm font-mono'>{this.state.token}</span>
          </div>
        )}
        <Button variant='secondary' onClick={() => this.setState({ confirmReset: true })}>Reset Token</Button>
        <p className='text-xs text-slate-500'>Contact support@nssurge.com if you want to use API to update user list.</p>
      </div>
    )
  }

  renderContent () {
    switch (this.state.tab) {
      case 'details':
        return this.renderDetails()
      case 'password':
        return this.renderPassword()
      case 'quota':
        return this.renderQuota()
      case 'token':
        return this.renderToken()
      default:
        return null
    }
  }

  render () {
    return (
      <>
        <Modal
          open={this.props.show}
          onClose={this.props.onClose}
          title='Enterprise Account'
          footer={[
            <Button key='close' variant='ghost' onClick={this.props.onClose}>Close</Button>
          ]}
        >
          {this.state.loading
            ? <div className='py-10 text-center text-slate-500'>Loading…</div>
            : (
              <>
                <div className='flex gap-4 text-sm font-semibold mb-4'>
                  {['details', 'password', 'quota', 'token'].map(tab => (
                    <button
                      key={tab}
                      className={`pb-1 border-b-2 ${this.state.tab === tab ? 'border-ink text-ink' : 'border-transparent text-slate-400'}`}
                      onClick={() => this.setState({ tab })}
                    >
                      {tab === 'details' && 'Details'}
                      {tab === 'password' && 'Update Password'}
                      {tab === 'quota' && 'Default User Quota'}
                      {tab === 'token' && 'API Token'}
                    </button>
                  ))}
                </div>
                {this.renderContent()}
              </>
              )}
        </Modal>
        <Modal
          open={this.state.confirmReset}
          onClose={() => this.setState({ confirmReset: false })}
          title='Reset API token?'
          footer={[
            <Button key='cancel' variant='ghost' onClick={() => this.setState({ confirmReset: false })}>Cancel</Button>,
            <Button key='reset' onClick={this.resetToken}>Reset</Button>
          ]}
        >
          <p>Are you sure you want to reset the API token? This action cannot be undone.</p>
        </Modal>
      </>
    )
  }
}

export default Profile
